<div class="no-results-message" *ngIf="!results.length">
  <p>We're sorry. No providers found for your search term. Please try a different term.</p>
  <p>Need help finding a provider? Let us help you find the right one. <a href="tel:+13367169253">336-716-WAKE (9253)</a></p>
  <p><a class="reset-search" (click)="resetSearch()">Start a new search</a></p>
</div>
<ul class="search-results-new">
  <li *ngFor="let result of results" class="search-result-new">
    <wfbhsearch-search-result [result]="result">
    </wfbhsearch-search-result>
  </li>
</ul>
<div class="pagination" *ngIf="numPages > 1">
  <nav aria-label="Search results navigation">
    <ul class="paginate">
      <li *ngIf="currentPage > 5">
        <a (click)="selectPage(0, 'first')" aria-label="First">
          <span aria-hidden="true">« First</span>
        </a>
      </li>
      <li *ngIf="currentPage > 1">
        <a (click)="selectPage(currentPage - 1, 'previous')" aria-label="Previous">
          <span aria-hidden="true">‹ Previous</span>
        </a>
      </li>
      <li *ngFor="let p of pageList">
        <a (click)="selectPage(p, 'direct')" [ngClass]="{'active': currentPage == p}">
          <span aria-hidden="true">{{ p + 1 }}</span>
        </a>
      </li>
      <li *ngIf="numPages > currentPage">
        <a (click)="selectPage(currentPage+1, 'next')" aria-label="Next">
          <span aria-hidden="true">Next ›</span>
        </a>
      </li>
      <li *ngIf="currentPage < (numPages - 5) && numPages > 10">
        <a (click)="selectPage(numPages-1, 'last')" aria-label="Last">
          <span aria-hidden="true">Last »</span>
        </a>
      </li>
    </ul>
  </nav>
</div>